import React from 'react';

import BestRankIcon from '../../assets/icons/BestRankIcon';
import CurrentStreakIcon from '../../assets/icons/CurrentStreakIcon';
import LeaguePromotionsIcon from '../../assets/icons/LeaguePromotionsIcon';
import Top500Icon from '../../assets/icons/Top500Icon';
import TopThreeFinishesIcon from '../../assets/icons/TopThreeFinishesIcon';
import { ICompetitionPerformance } from '../../utils/interfaces/DbInterfaces';
import { getLeagueInfo } from '../LeagueInfo/LeagueInfo';
import MetricBox from '../MetricBox/MetricBox';
import SectionWrapper from '../SectionWrapper';

import styles from './CompetitionPerformance.module.scss';

interface ICompetitionPerformanceProps {
  competitionPerformance: ICompetitionPerformance;
  className?: string;
}

const CompetitionPerformance = ({ competitionPerformance, className }: ICompetitionPerformanceProps) => {
  let bestTierId: string | undefined;
  let bestTierName: string | undefined;
  let bestTierIcon: React.ReactNode = <BestRankIcon />;

  if (typeof competitionPerformance.bestTier === 'string') {
    const leagueInfo = getLeagueInfo(competitionPerformance.bestTier);
    bestTierId = competitionPerformance.bestTier;
    bestTierName = leagueInfo.name;
    bestTierIcon = <img src={leagueInfo.icon} alt={leagueInfo.name} style={{ height: 32 }} />;
  } else if (competitionPerformance.bestTier && typeof competitionPerformance.bestTier === 'object') {
    bestTierId = competitionPerformance.bestTier.id;
    bestTierName = competitionPerformance.bestTier.name;
  }

  return (
    <SectionWrapper headerText='Competition Performance' className={`${styles.body_wrapper} ${className}`}>
      <MetricBox
        className={styles.metricBoxCustomHeight}
        icon={<TopThreeFinishesIcon />}
        title='Top 3 Finishes'
        value={competitionPerformance.topThreeFinishes}
      />
      <MetricBox
        className={styles.metricBoxCustomHeight}
        icon={<LeaguePromotionsIcon />}
        title='League Promotions'
        value={competitionPerformance.leaguePromotions}
      />
      <MetricBox
        className={styles.metricBoxCustomHeight}
        icon={<CurrentStreakIcon />}
        title='Current Streak'
        value={competitionPerformance.currentStreak}
      />
      <MetricBox
        className={styles.metricBoxCustomHeight}
        icon={bestTierIcon}
        title='Best Rank'
        value={bestTierId || competitionPerformance.bestRank}
        subtitle={bestTierName ? bestTierName.replace('League', '').trim() : undefined}
      />
      {competitionPerformance.topGlobal500Finishes ? (
        <MetricBox
          className={styles.metricBoxCustomHeight}
          icon={<Top500Icon />}
          title='Top 500 Placements'
          value={competitionPerformance.topGlobal500Finishes}
        />
      ) : null}
    </SectionWrapper>
  );
};

CompetitionPerformance.defaultProps = {
  className: '',
};

export default CompetitionPerformance;
